import React, { useState } from 'react';
import { 
  Box, 
  Paper, 
  TextField, 
  Button, 
  Typography,
  Alert
} from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const theme = {
  primary: '#EF582E',
  secondary: '#F17F5E',
  background: '#FFF9F5',
  text: '#2D3748',
  fontFamily: '"Plus Jakarta Sans", sans-serif',
};

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (login(username, password)) {
      navigate('/reports');
    } else {
      setError('Identifiants incorrects');
    }
  };

  return (
    <Box sx={{ 
      maxWidth: 400, 
      mx: 'auto', 
      mt: 8,
      p: 3,
      fontFamily: theme.fontFamily
    }}>
      <Paper
        elevation={0}
        sx={{ 
          p: 4,
          borderRadius: 2,
          backgroundColor: theme.background,
          border: `1px solid ${theme.primary}40`
        }}
      >
        <Typography 
          variant="h5" 
          component="h1" 
          gutterBottom
          sx={{ 
            mb: 3,
            color: theme.primary,
            fontWeight: 'bold',
            textAlign: 'center'
          }}
        >
          Connexion
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <form onSubmit={handleSubmit}>
          <TextField
            label="Identifiant"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            fullWidth
            margin="normal"
            required
            sx={{
              '& .MuiOutlinedInput-root': {
                '&.Mui-focused fieldset': {
                  borderColor: theme.primary
                }
              },
              '& .MuiInputLabel-root.Mui-focused': {
                color: theme.primary
              }
            }}
          />
          <TextField
            label="Mot de passe"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
            margin="normal"
            required
            sx={{
              '& .MuiOutlinedInput-root': {
                '&.Mui-focused fieldset': {
                  borderColor: theme.primary
                }
              },
              '& .MuiInputLabel-root.Mui-focused': {
                color: theme.primary
              }
            }}
          />
          <Button
            type="submit"
            variant="contained"
            fullWidth
            sx={{ 
              mt: 3,
              bgcolor: theme.primary,
              fontFamily: theme.fontFamily,
              boxShadow: 'none',
              '&:hover': {
                bgcolor: theme.secondary,
                boxShadow: 'none'
              }
            }}
          >
            Se connecter
          </Button>
        </form>
      </Paper>
    </Box>
  );
};

export default Login; 